import React, { useEffect, useState } from "react";
import "./TicketStatus.css";
import ErrorPopup from "../Popups/ErrorPopup/ErrorPopup";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Loading from "../../../../../application/commons/loading/loading";
import BackButton from "../../../../../application/commons/back-button/back-button";
import CustomTabs from "../CustomTabs/CustomTabs";
import { getTicketsCvaURL } from "../../utils/constants";
import TicketCard from "./TicketCard";
import { RootState } from "../../../../../utils/redux-store/appStore";
import { useTheme } from "@mui/material";


const TicketStatus: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const error_msg =
    "Your servicenow account is not available. Please contact admin to create one";
  const [searchTermAll, setSearchTermAll] = useState("");
  const [searchTermActive, setSearchTermActive] = useState("");
  const [searchTermClosed, setSearchTermClosed] = useState("");
  const userProfile = useSelector((store: any) => store.login.loginDetails);

  const [activeCva, setActiveCva] = useState<[]>([]);
  const [closedCva, setClosedCva] = useState<[]>([]);
  const theme = useTheme()
  const [totalTicketsCva, setTotalTicketsCva] = useState<any>([]);
  const [filteredData, setFilteredData] = useState<any>(totalTicketsCva);
  const [filteredActiveCvaData, setFilteredActiveCvaData] = useState<any>(activeCva);
  const [filteredClosedCvaData, setFilteredClosedCvaData] = useState<any>(closedCva);
  const accountExist = useSelector((state: RootState) => state.serviceNowDetails.accountExist);

  useEffect(() => {
    if (accountExist) {
      getTicketsCva();
    } else {
      setLoading(false);
    }

    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  const remove = (tab: string) => {
    if (tab === 'All') {
      setSearchTermAll("");
      setFilteredData(totalTicketsCva);
    }
    if (tab === 'Open') {
      setSearchTermActive("");
      setFilteredActiveCvaData(activeCva);
    }
    if (tab === 'Closed') {
      setSearchTermClosed("");
      setFilteredClosedCvaData(closedCva);
    }
  };

  const handleSearch = (e: any, tab: string) => {
    const valueable = e.target.value;
    if (tab === 'All') {
      setSearchTermAll(valueable);
      const filteredTickets = totalTicketsCva?.filter((currentVal: any) =>
        currentVal.number?.toLowerCase()?.includes(valueable?.toLowerCase())
      );
      setFilteredData(filteredTickets);
    }
    if (tab === 'Open') {
      setSearchTermActive(valueable);
      const filteredTickets = activeCva?.filter((currentVal: any) =>
        currentVal.number?.toLowerCase()?.includes(valueable?.toLowerCase())
      );
      setFilteredActiveCvaData(filteredTickets);
    }
    if (tab === 'Closed') {
      setSearchTermClosed(valueable);
      const filteredTickets = closedCva?.filter((currentVal: any) =>
        currentVal.number?.toLowerCase()?.includes(valueable?.toLowerCase())
      );
      setFilteredClosedCvaData(filteredTickets);
    }
  };

  // const checkIfUserAccountExists = async () => {
  //   try {
  //     const options = {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //       }
  //     };
  //     const result = await (await fetch(`${checkUserAccountExists}?email=${userProfile.email}`, options)).json();
  //     if (result) {
  //       setAccountExist(true);
  //       getTicketsCva();
  //     } else {
  //       setLoading(false);
  //       setAccountExist(false);
  //     }
  //   } catch (err) {
  //     setAccountExist(false);
  //     console.log("ERROR :::", err);
  //   }
  // }

  const getTicketsCva = async () => {
    try {
      const options = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      };
      const result: any = await (await fetch(`${getTicketsCvaURL}?email=${userProfile.email}&limit=10`, options)).json();
      if (result) {
        setLoading(false);
        setActiveCva(result.activeTickets);
        setFilteredActiveCvaData(result.activeTickets);
        setClosedCva(result.resolvedOrClosed);
        setFilteredClosedCvaData(result.resolvedOrClosed);
        setTotalTicketsCva([...result.activeTickets, ...result.resolvedOrClosed]);
        setFilteredData([...result.activeTickets, ...result.resolvedOrClosed]);
      }
    } catch (err) {
      console.log('ERROR :::', err);
    }
  }

  const tabData = [
    {
      name: "All",
      content: (
        <>
          <div
            style={{
              margin: "12px 10px",
              display: "flex",
            }}
          >
            <section style={{ width: "100%" }} className="chat-input-container">
              <form className="form_length" action="#" method="post">
                <div className="iconSearch"></div>
                <input
                  type="text"
                  maxLength={20}
                  className="ticketstatus-search"
                  value={searchTermAll}
                  onChange={(e) => handleSearch(e, 'All')}
                  placeholder="Search Ticket Number"
                  aria-label="Number"
                />
                <div>
                  <div className="closeicn" onClick={() => remove('All')}></div>
                </div>
              </form>
            </section>
          </div>
          <div className="list_tickets">
            {filteredData?.length > 0 ? (
              filteredData?.map((ticket: any) => (
                <TicketCard key={ticket?.number} ticket={ticket} />
              ))
            ) : (
              <>
                <div> No Search Result Found </div>
              </>
            )}
          </div>
        </>
      ),
    },
    {
      name: "Open",
      content: (
        <>
          <div
            style={{
              margin: "12px 10px",
              display: "flex",
            }}
          >
            <section style={{ width: "100%" }} className="chat-input-container">
              <form className="form_length" action="#" method="post">
                <div className="iconSearch"></div>
                <input
                  type="text"
                  maxLength={20}
                  className="textarea"
                  value={searchTermActive}
                  onChange={(e) => handleSearch(e, 'Open')}
                  placeholder="Search Ticket Number"
                  aria-label="Number"
                />
                <div>
                  <div className="closeicn" onClick={() => remove('Open')}></div>
                </div>
              </form>
            </section>
          </div>
          <div className="list_tickets">
            {filteredActiveCvaData?.length === 0 ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                  }}
                >
                  No Open Ticket
                </div>
              </>
            ) : (
              filteredActiveCvaData?.map((ticket: any) => (
                <TicketCard ticket={ticket} key={ticket?.number} />
              ))
            )}
          </div>
        </>
      ),
      badge: filteredActiveCvaData?.length === 0 ? 0 : filteredActiveCvaData?.length
    },
    {
      name: "Closed",
      content: (
        <>
          <div
            style={{
              margin: "12px 10px",
              display: "flex",
            }}
          >
            <section style={{ width: "100%" }} className="chat-input-container">
              <form className="form_length" action="#" method="post">
                <div className="iconSearch"></div>
                <input
                  type="text"
                  maxLength={20}
                  className="textarea"
                  value={searchTermClosed}
                  onChange={(e) => handleSearch(e, 'Closed')}
                  placeholder="Search Ticket Number"
                  aria-label="Number"
                />
                <div>
                  <div className="closeicn" onClick={() => remove('Closed')}></div>
                </div>
              </form>
            </section>
          </div>
          <div className="list_tickets">
            {filteredClosedCvaData?.length === 0 ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                  }}
                >
                  No Closed Ticket
                </div>
              </>
            ) : (
              filteredClosedCvaData.map((ticket: any) => (
                <TicketCard key={ticket?.number} ticket={ticket} />
              ))
            )}
          </div>
        </>
      ),
      badge: filteredClosedCvaData?.length === 0 ? '0' : filteredClosedCvaData?.length
    },
  ];

  if (loading) {
    return (
      <>
        <Loading />
      </>
    );
  }

  return (
    <>
      {accountExist ? (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <div className="flex" style={{ alignItems: "center" }}>
            <div id="back" className="back">
              <BackButton />
            </div>
            <div className="status">
              <p style={{ cursor: "pointer", margin: "0px" }}>Ticket Status</p>
            </div>
            <div className="rectangle">
              <Link
                to="/mn/desktop/raise-ticket"
                style={{ textDecoration: "none" }}
              >
                <button
                  className="btn btn-primary"
                  style={{ display: "flex", gap: "10px", alignItems: "center" }}
                >
                  <i className="bi bi-ticket tiktIcn"></i>
                  <div className="raiseTicket">Raise Ticket</div>
                </button>
              </Link>
            </div>
          </div>
          <div style={{ borderRadius: "24px" }} className={`ticketstatus-main_div-${theme.palette.mode}`}>
            <div className="tabs" id="tabs">
              <CustomTabs data={tabData} />
            </div>
          </div>
        </div>
      ) : (
        <ErrorPopup error_msg={error_msg} />
      )}
    </>
  );
};

export default TicketStatus;
